import { onHandleFakeId } from '@/utils/handlers';
import { required } from 'vuelidate/lib/validators';

const initInfoAnswer = (listAnswer = []) => {
    return {
        make_id: onHandleFakeId(listAnswer),
        answer: '',
        pattern: ''
    };
};

const initFormFaq = (data = null) => {
    return {
        sheet: {
            id: data?.sheet?.id ?? '',
            value: data?.sheet?.value ?? ''
        },
        campaign_type: {
            id: data?.campaign_type?.id ?? '',
            value: data?.campaign_type?.value ?? ''
        },
        has_answer_default: data?.has_answer_default ?? false,
        categories: data?.categories ?? [],
        application_type: data?.application_type ?? [],
        question: data?.question ?? '',
        answers: data?.answers ?? [initInfoAnswer()],
        extension: {
            secretariat_notices: data?.extension?.secretariat_notices ?? '',
            message_to: data?.extension?.message_to ?? ''
        }
    };
};

const configFormFaq = () => {
    return {
        sheets: { required },
        campaign_types: { required },
        application_type: { required },
        question: { required },
        answers: {
            $each: {
                answer: { required },
                pattern: {}
            }
        },
        extension: {
            secretariat_notices: {},
            message_to: {}
        }
    };
};

export { initFormFaq, initInfoAnswer, configFormFaq };
